var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardPaymentSumaryContent_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { func, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Link, Text } from '@philips-internal/oswald-ui-components/lib/components';
import React, { Component } from 'react';
import './card-payment-summary-content.css';
import { LanguageService, MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { NumberFormatUtils } from '../../util/number-format-utils';
import { isFunction, isMobileResolution } from '@philips-internal/oswald-ui-utils';
import { CardPaymentSummaryApi } from '..';
import moment from 'moment';
let CardPaymentSumaryContent = class CardPaymentSumaryContent extends Component {
    static { CardPaymentSumaryContent_1 = this; }
    static { this.propTypes = { className: string, onClickReportButton: func, uuid: string, width: number }; }
    static { this.defaultProps = { width: 6 }; }
    openReport() {
        const { onClickReportButton } = this.props;
        if (isFunction(onClickReportButton)) {
            onClickReportButton();
        }
    }
    render() {
        const { uuid, className, width = CardPaymentSumaryContent_1.defaultProps.width, emitionDate, expirationDate, initialValue, amountFine, amountInterests, totalValue } = this.props;
        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        let emitionDateFormat = moment(emitionDate).locale(localeStr).format('DD MMMM YY');
        let expirationDateFormat = moment(expirationDate).locale(localeStr).format('DD MMMM YY');
        let textEmitionDate = MessageService.translate('patient.emition-date');
        const currencySymbol = MessageService.translate('patient.currency-symbol');
        const initialValueFormatted = NumberFormatUtils.formatToCurrentLanguage(initialValue, currencySymbol, true);
        const amountFineFormatted = NumberFormatUtils.formatToCurrentLanguage(amountFine, currencySymbol, true);
        const amountInterestsFormatted = NumberFormatUtils.formatToCurrentLanguage(amountInterests, currencySymbol, true);
        const totalValueFormatted = NumberFormatUtils.formatToCurrentLanguage(totalValue, currencySymbol, true);
        if (isMobileResolution()) {
            emitionDateFormat = ModelService.format('date', emitionDate, { type: 'shortDate' });
            expirationDateFormat = ModelService.format('date', expirationDate, { type: 'shortDate' });
            textEmitionDate = MessageService.translate('profile.patient.issuance');
        }
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: className },
            React.createElement("div", { className: 'payment-summary' },
                React.createElement("h3", null, `${MessageService.translate('patient.summary')}`),
                React.createElement("div", { className: "payment-dates" },
                    React.createElement("span", { className: "payment-emition-date" },
                        React.createElement("span", { className: "label-date" },
                            React.createElement(Text, { value: `${textEmitionDate}:` })),
                        React.createElement("span", { className: "date" },
                            React.createElement(Text, { bold: true, value: emitionDateFormat }))),
                    React.createElement("span", { className: "payment-expired-date" },
                        React.createElement("span", { className: "label-date" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.expired-date')}:` })),
                        React.createElement("span", { className: "date" },
                            React.createElement(Text, { bold: true, value: expirationDateFormat })))),
                React.createElement("div", { className: "payment-block-item" },
                    React.createElement("div", { className: "payment-item-value" },
                        React.createElement("span", { className: "description-value" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.payment-initial-value')}` })),
                        React.createElement("span", { className: "value payment-item-initial-value" },
                            React.createElement(Text, { bold: true, value: initialValueFormatted })))),
                React.createElement("div", { className: "payment-block-item" },
                    React.createElement("div", { className: "payment-item-value" },
                        React.createElement("span", { className: "description-value" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.payment-amount-fine')}` })),
                        React.createElement("span", { className: "value" },
                            React.createElement(Text, { value: amountFineFormatted }))),
                    React.createElement("div", { className: "payment-item-value" },
                        React.createElement("span", { className: "description-value" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.payment-amount-interests')}` })),
                        React.createElement("span", { className: "value" },
                            React.createElement(Text, { value: amountInterestsFormatted })))),
                React.createElement("div", { className: "payment-item-value" },
                    React.createElement("span", { className: 'payment-link' },
                        React.createElement(Link, { onClick: () => this.openReport(), value: MessageService.translate('patient.see-billing-details') })),
                    React.createElement("div", { className: "final-value" },
                        React.createElement("span", { className: "description-value" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.payment-total-value')}:` })),
                        React.createElement("span", { className: "value payment-item-final-value" },
                            React.createElement(Text, { bold: true, value: totalValueFormatted })))))));
    }
};
CardPaymentSumaryContent = CardPaymentSumaryContent_1 = __decorate([
    AwesomeComponent({ api: CardPaymentSummaryApi, type: ComponentType.DATA_DISPLAY })
], CardPaymentSumaryContent);
export default CardPaymentSumaryContent;
//# sourceMappingURL=card-payment-summary-content.js.map